// constants.js

export const THREE_HOUR_DEVICES = [
  'habitat',
];

export const PORTEL_STATUS_DEVICES = [
  'habitat',
];

export const ONLINE_STATUS_DEVICES = [
  'habitat',
];

export const CHART_NOT_INCLUDE_DEVICES = [
  'M280014', 'M280011', 'M280010', 'M280013',
];

export const CHART_SHOW_DEVICES = [
  'yourspace', 'wiley', 'campus', 'campus2', 'oceans', 'vietnom', 'paras',
  'bata', 'steelo', 'grandcentral', 'sarthakpalace', 'alankaram', 'ARS',
  'rajiv',
];

export const CHART_NOT_SHOW_DEVICES = [
  'yourspace', 'wiley', 'campus', 'campus2', 'oceans', 'vietnom', 'paras',
  'bata', 'steelo', 'sarthakpalace', 'ARS', 'alankaram', 'rajiv',
];

export const AUTO_CUT_SHOW_DEVICES = [
  'aliste', 'laffaire', 'steelo',
];

export const notShowSystemValuesWhenMultiDay = [
  'temperature', 'onlineStatus', 'ACStatus', 'applianceHealth', 'unitSaved', 'moneySaved', "moneySaving", 'unitSaving', 'saving', 'carbonSaving','applianceOnTime'
];